import React from 'react';
import { Box } from '@fiverr-private/theme';

export function AspectRatioContainer({ children, ...rest }) {
    return (
        <div style={{ paddingTop: '60%', position: 'relative' }}>
            <Box position="absolute" top={0} left={0} width="100%" height="100%" {...rest}>
                {children}
            </Box>
        </div>
    );
}
